<section class="cr-static cr-pricing">
  <div class="cr-static__inner">
    <header class="cr-static__hero">
      <span class="cr-static__eyebrow">Für Handwerker</span>
      <h1 class="cr-static__title">
        Ein Preismodell.<br>Ohne Sternchen.
      </h1>
      <p class="cr-static__lead">
        15&nbsp;% Provision auf vermittelte Aufträge. Keine Lead-Gebühr.
        Keine Grundgebühr. Keine Premium-Slots.
      </p>
    </header>

    <section class="cr-pricing__panels" aria-label="Was kostet Craftly">
      <article class="cr-pricing__panel cr-pricing__panel--free">
        <span class="cr-pricing__panel-eyebrow">Kostenfrei</span>
        <h2 class="cr-pricing__panel-title">Was nichts kostet</h2>
        <ul class="cr-pricing__panel-list">
          <li>Profil anlegen</li>
          <li>Verifizierung &amp; Onboarding</li>
          <li>Anfragen einsehen</li>
          <li>Angebote abgeben</li>
          <li>Kalender + Profil-Pflege</li>
          <li>Hilfe &amp; Support</li>
        </ul>
      </article>

      <article class="cr-pricing__panel cr-pricing__panel--paid">
        <span class="cr-pricing__panel-eyebrow">Provisionspflichtig</span>
        <h2 class="cr-pricing__panel-title">Wo wir mitverdienen</h2>
        <p class="cr-pricing__panel-lead">
          <strong>15&nbsp;%</strong> auf Aufträge, die wir vermitteln und die du
          erfolgreich durchführst.
        </p>
        <hr class="cr-pricing__panel-rule">
        <p class="cr-pricing__panel-foot">
          <strong>Stripe-Gebühren</strong> ca.&nbsp;1,4&nbsp;% + 0,25&nbsp;€,
          separat vom Auszahlungsbetrag ausgewiesen.
        </p>
      </article>
    </section>

    <section class="cr-pricing__example" aria-label="Beispiel-Rechnung">
      <h2 class="cr-static__h2">Beispiel-Rechnung</h2>
      <p class="cr-pricing__example-lead">
        Heizungswartung, <strong>240&nbsp;€</strong> Festpreis:
      </p>
      <table class="cr-pricing__example-table">
        <tbody>
          <tr>
            <th scope="row">Kunde zahlt</th>
            <td class="cr-pricing__example-amount">240,00&nbsp;€</td>
          </tr>
          <tr class="cr-pricing__example-deduct">
            <th scope="row">– Plattform-Provision (15&nbsp;%)</th>
            <td class="cr-pricing__example-amount">– 36,00&nbsp;€</td>
          </tr>
          <tr class="cr-pricing__example-deduct">
            <th scope="row">– Stripe-Gebühr</th>
            <td class="cr-pricing__example-amount">– 3,61&nbsp;€</td>
          </tr>
          <tr class="cr-pricing__example-total">
            <th scope="row">Auszahlung an dich</th>
            <td class="cr-pricing__example-amount">200,39&nbsp;€</td>
          </tr>
        </tbody>
      </table>
      <p class="cr-pricing__example-note">
        Die Auszahlung erfolgt in der Regel 2–3 Werktage nach Abschluss des Auftrags.
        Provisionsrechnung wird separat zugestellt.
      </p>
    </section>

    <section class="cr-pricing__compare" aria-label="Vergleich der Abrechnungsmodelle">
      <h2 class="cr-static__h2">Lead-Modell oder Provision?</h2>
      <div class="cr-pricing__compare-grid">
        <article class="cr-pricing__compare-card cr-pricing__compare-card--others">
          <span class="cr-pricing__compare-tag">Lead-Modell</span>
          <p class="cr-pricing__compare-amount">pro Kontakt</p>
          <p class="cr-pricing__compare-desc">
            Lead-Modelle berechnen <strong>oft eine Gebühr je Kontakt</strong> —
            auch wenn kein Auftrag zustande kommt.
          </p>
        </article>
        <article class="cr-pricing__compare-card cr-pricing__compare-card--craftly">
          <span class="cr-pricing__compare-tag">Provisionsmodell Craftly</span>
          <p class="cr-pricing__compare-amount">15&nbsp;%</p>
          <p class="cr-pricing__compare-desc">
            <strong>nur</strong> wenn ein Auftrag zustande kommt.
          </p>
        </article>
      </div>
      <p class="cr-pricing__compare-line">
        Wir verdienen nur, wenn du verdienst.
      </p>
    </section>

    <section class="cr-pricing__faq" aria-label="Häufige Fragen zum Preismodell">
      <h2 class="cr-static__h2">Häufige Fragen</h2>
      <ul class="cr-pricing__faq-list">
        @for (faq of faqs; let i = $index; track faq.q) {
          <li class="cr-pricing__faq-item" [class.is-open]="openIndex() === i">
            <button type="button" class="cr-pricing__faq-q"
                    [attr.aria-expanded]="openIndex() === i"
                    (click)="toggle(i)">
              <span>{{ faq.q }}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                   stroke-linejoin="round" aria-hidden="true">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            @if (openIndex() === i) {
              <div class="cr-pricing__faq-a">{{ faq.a }}</div>
            }
          </li>
        }
      </ul>
      <a routerLink="/hilfe/handwerker" class="cr-pricing__faq-all">
        Alle Fragen ansehen →
      </a>
    </section>

    <section class="cr-static__cta">
      <h2 class="cr-static__cta-title">Bereit, Craftly zu nutzen?</h2>
      <p class="cr-static__cta-lead">
        Anmeldung dauert keine 10 Minuten. Auszahlung über Stripe.
      </p>
      <div class="cr-static__cta-row">
        <a routerLink="/registrieren/handwerker" class="cr-btn cr-btn--primary">
          Jetzt als Handwerker anmelden
        </a>
        <a routerLink="/hilfe/handwerker" class="cr-btn cr-btn--ghost">
          Häufige Fragen
        </a>
      </div>
    </section>

    <p class="cr-pricing__disclaimer">
      Provisionssätze gelten ab 01.06.2026 und können mit 30 Tagen Vorlauf angepasst werden.
      Bestehende Buchungen sind von Änderungen nicht betroffen — der Provisionssatz wird zum
      Zeitpunkt der Buchung fixiert. Hauptparameter der Sortier-Reihenfolge in
      <a routerLink="/agb/handwerker">AGB §&nbsp;14</a>.
    </p>
  </div>
</section>
